<template>
  <nav v-if="prev || next" :class="$style.root">
    <div :class="$style.content">
      <div :class="$style.column">
        <i18nLink
          v-if="prev?.title"
          :class="$style.link"
          :to="routeObject(prev?.slug, prev?.query)"
          dir="prev"
        >
          <SvgoArrow :class="$style.arrow" /> <span>{{ prev?.title }}</span>
        </i18nLink>
      </div>

      <div :class="$style.column">
        <i18nLink
          v-if="next?.title"
          :class="$style.link"
          :to="routeObject(next?.slug, next?.query)"
          dir="next"
        >
          <span>{{ next?.title }}</span> <SvgoArrow :class="$style.arrow"  />
        </i18nLink>
      </div>
    </div>
  </nav>
</template>

<script lang="ts" setup>
const props = defineProps({
  prev: [Object, null],
  next: [Object, null]
})

const nuxtApp = useNuxtApp()
const routeName = computed(() => nuxtApp.$getRouteBaseName())
const routeObject = (slug: string, query: object = {}) => {
  return {
    name: routeName.value,
    params: { slug },
    query: query
  }
}
</script>

<style module>
.root {
  composes: container font-helvetica font-size-small from global;

  user-select: none;

  margin-top: var(--unit--vertical);
}

.content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--unit--default);
}

.column {
  overflow: hidden;
  display: flex;
}

.link {
  composes: reset-link button from global;

  display: flex;
  align-items: center;
  gap: .5ch;

  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.link span {
  text-overflow: ellipsis;
  overflow: hidden;
}

.link[dir="next"] {
  margin-left: auto;
}

.arrow {
  height: calc(var(--fs, 1em) / 2.25);
  stroke-width: .085em;
  stroke: currentColor;
  overflow: visible;
}

.link[dir="next"] .arrow {
  transform: rotateZ(180deg);
}
</style>
